<template>
<div
  id="inbox"
  class="page page-on-center close-picker rowBackgroundHomepage"
  data-page="inbox-page">


  <div class="page-content infinite-scroll"
    style="z-index:9">
    <div class="listPage">
      <div class="row showLargeScreenOnly">
        <div class="row rowSearchBar">
          <back-button class="firstBlock"></back-button>
          <extract-csv-button @startCSVextraction="extractCSV(paymentsList)"></extract-csv-button>
          <button class="milkyBlockBlack firstBlock new-button-white"
                  @click="refreshPaymentsGroup()">
            <f7-icon f7="refresh"></f7-icon>
            <span class="showLargeScreenOnly fab-label">
              {{ $t('common.rfrsh') }}
            </span>
          </button>
        </div>
      </div>

      <div class="row">
        <div class="searchForm col-md-12">
          <div class="requestsList">
            <cm-messages-filter
              class="researchfilter"
              style="position:relative;z-index:10"
              :isPayments="true"
              :received="true"
              :listMainTitle="currentPaymentsGroup[0].groupname"
              :filterType="'details'"
              @applyFilter="applyFilter($event)">
            </cm-messages-filter>
            <f7-accordion-item class="accordionForm" :expanded="true">
              <f7-accordion-toggle class="accordionToggle">
                <transactions-list
                  :filterBy="false"
                  v-bind:messages="currentPaymentsGroup"
                  :serviceId="serviceId"
                  style="border-radius: 0;">
                </transactions-list>
              </f7-accordion-toggle>
              <f7-accordion-content>
                <spinner v-if="activateSpinner"></spinner>
                <direct-payments-list v-else-if="detailsDone"
                  :filterBy="false"
                  :payments="paymentsList"
                  @get-folder-info="getFolderInfo()"
                  :showPaymentMainDetails="true">
                </direct-payments-list>
              </f7-accordion-content>
            </f7-accordion-item>
          </div>
        </div>
      </div>
      <div class="toolbarPageBottomBlank"></div>
    </div>
  </div>
</div>
</template>

<script>
import {errorMessageAlert} from '@/helpers/alert'
import DirectPaymentsList from '@/pages/requests/detailPages/directPaymentDetailPages/DirectPaymentsList.vue'
import MessagesFilter from '@/components/common/Filter'
import Spinner from '@/components/common/spinner.vue'
import backButton from '@/components/common/backButton.vue'
import TransactionsList from '@/pages/requests/TransactionsList.vue'
import ExtractCSVbutton from '@/components/common/extractCSVbutton.vue'

// For .csv extraction
// import {statusLabel} from '@/helpers/labels'
// import moment from 'moment'

export default {
  name: 'directPaymentsGroupDetailPage',
  components: {
    'direct-payments-list': DirectPaymentsList,
    'cm-messages-filter': MessagesFilter,
    'spinner': Spinner,
    'transactions-list': TransactionsList,
    'back-button': backButton,
    'extract-csv-button': ExtractCSVbutton
  },
  data () {
    return {
      currentPaymentsGroup: [],
      paymentsList: [],
      activateSpinner: false,
      detailsDone: true,
      serviceId: this.$engine.user.currentService.id.toString()
    }
  },
  created () {
    this.currentPaymentsGroup.push(this.$engine.services.directPayments.currentSendbox)
    this.getPaymentsList()
  },
  methods: {
    // Fonction à définir en fonction des modèles de modélisation associée
    getPaymentsList (filterConditions = {}) {
      /* let that = this
      this.$engine.services.businessDocuments.getDetails(
        this.currentPaymentsGroup[0].idgroup,
        filterConditions
      )
      .then(resp => {
        that.paymentsList = resp.data.payments
      })
      .catch(error => {
        errorMessageAlert(error, that, that.$i18n)
      }) */

      // Mettre ici le json qui va être retourné temporairement
      this.paymentsList = []
    },
    // Réactualisation de la page de paiements
    refreshPaymentsGroup: function () {
      /* this.detailsDone = false
      this.activateSpinner = true
      this.getPaymentsList() */
    },
    // Application du filtre de recherche
    applyFilter (filterConditions) {
      if (filterConditions.documentStatus) {
        filterConditions.documentStatus = JSON.stringify(filterConditions.documentStatus)
      }
      this.detailsDone = false
      this.activateSpinner = true
      this.getPaymentsList(filterConditions)
    },
    // Updating one payment status
    updatePaymentStatus (newPaymentStatus) {
      let that = this
      that.$engine.services.directPayments.updatePaymentStatus({
        GroupId: this.currentPaymentsGroup[0].idgroup,
        GroupStatus: newPaymentStatus
      }).then(response => {
        if (response.status === 200) {
          that.$f7.modal({
            title: this.$t('businessDocuments.updated_folder'),
            text: '<span class="preloader"></span>'
          })
          that.currentFolder[0].status = newPaymentStatus
          setTimeout(function () {
            that.$f7.closeModal()
          }, 1000)
        }
      }).catch(error => {
        errorMessageAlert(error, that)
      })
    },
    // To do: develop CSV extraction
    extractCSV (paymentsList) {
      /* let lines = this.$t('businessDocuments.emission_reception_date') + ';' +
        this.$t('businessDocuments.request_name') + ';' +
        this.$t('businessDocuments.document_type') + ';' +
        this.$t('common.status.status_label') + ';' +
        this.$t('common.recipient_name') + '\r\n'

      for (let doc in docList) {
        lines += docList[doc]['date'] + ';' +
        docList[doc]['name'] + ';' +
        this.$i18n.t(documentSerialize[docList[doc]['type']].label) + ';' +
        statusLabel(this.$i18n, 'Doc_' + docList[doc]['status']) + ';' +
        docList[doc].correspondent + '\r\n'
      }
      const linkSource = 'data:text/csv;charset:utf-8;base64,' + btoa(lines)
      const downloadLink = document.createElement('a')
      let today = moment()
      const fileName = this.currentFolder[0].reference + '_' + today.unix() + '.csv'

      downloadLink.href = linkSource
      downloadLink.download = fileName
      downloadLink.click() */
    }
  }
}

</script>
